import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.5",
  "description": "Turborepo 1.5는 Monorepo Handbook을 제공하고, 'run' 명령을 생략하며, 프루닝을 개선하는 등 많은 기능을 제공합니다!",
  "date": "2022/09/19",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 1.5는 문서 및 개발자 경험의 큰 도약이며 turbo prune에 대한 주요 개선 사항을 제공합니다:"
  }, {
    "heading": "",
    "content": "Monorepo Handbook: 워크스페이스, 코드 공유, 일반적인 도구 통합 등에 대한 가이드인 모노레포를 위한 누락된 매뉴얼을 만들었습니다."
  }, {
    "heading": "",
    "content": "run 생략: turbo run <task>를 이제 turbo <task>로 단축할 수 있습니다"
  }, {
    "heading": "",
    "content": "turbo prune이 이제 pnpm과 yarn 2+를 지원합니다: 이제 pnpm과 yarn@berry에서 모노레포 프루닝이 지원됩니다."
  }, {
    "heading": "",
    "content": "turbo.json의 환경 변수 개선: 환경 변수는 이제 Turborepo 파이프라인 구성의 일급 시민입니다."
  }, {
    "heading": "",
    "content": "package.json 해싱 변경: 작업 실행 시 package.json을 해싱하는 방법을 개선했습니다."
  }, {
    "heading": "",
    "content": "npm install turbo@latest를 실행하여 오늘 업데이트하세요."
  }, {
    "heading": "monorepo-handbook",
    "content": "모노레포를 처음 설정하는 것은 종종 많은 새로운 개념을 탐색하는 것을 의미합니다. 워크스페이스, 패키지 설치, 코드 공유 및 종속성 관리 등을 이해해야 합니다."
  }, {
    "heading": "monorepo-handbook",
    "content": "이는 종종 처음부터 모노레포를 설정하려는 사람들이 다양한 문서 사이트에서 정보를 모아야 함을 의미했습니다. 먼저 pnpm, 그 다음 tsup, 다시 changesets, 그리고 마지막으로 Turborepo로 돌아왔습니다."
  }, {
    "heading": "monorepo-handbook",
    "content": "우리는 Monorepo Handbook로 이 격차를 메우고자 합니다. 모노레포로 배포를 성공시키는 데 필요한 모든 도구를 통합하는 방법에 대한 가이드를 만들었습니다:"
  }, {
    "heading": "monorepo-handbook",
    "content": "패키지 설치"
  }, {
    "heading": "monorepo-handbook",
    "content": "린팅"
  }, {
    "heading": "monorepo-handbook",
    "content": "개발 작업"
  }, {
    "heading": "monorepo-handbook",
    "content": "앱 빌드"
  }, {
    "heading": "monorepo-handbook",
    "content": "패키지 게시"
  }, {
    "heading": "run-생략",
    "content": "이제 turbo <task>를 사용하여 Turborepo CLI로 작업을 실행할 수 있습니다."
  }, {
    "heading": "run-생략",
    "content": "작업 이름이 기본 제공 turbo 하위 명령과 충돌하는 경우 대신 하위 명령을 실행합니다. 즉, prune, run 또는 login과 같은 작업 이름은 사용하지 않아야 합니다. 이들은 기본 제공 하위 명령이기 때문입니다."
  }, {
    "heading": "run-생략",
    "content": "turbo run <task>는 계속 작동하며 더 이상 사용하지 않을 계획은 없습니다."
  }, {
    "heading": "pnpm-및-yarn-2에서-이제-prune-지원",
    "content": "turbo prune이 이제 pnpm, yarn 및 yarn 2+를 지원한다는 것을 발표하게 되어 기쁩니다."
  }, {
    "heading": "pnpm-및-yarn-2에서-이제-prune-지원",
    "content": "turbo prune을 사용하여 주어진 대상 애플리케이션과 그 종속성에 필요한 올바른 종속성이 포함된 전용 lockfile과 함께 모노레포의 프루닝된 하위 집합을 만들 수 있습니다. 이는 Docker 이미지 내에서 Turborepo를 효율적으로 사용하는 데 특히 유용합니다."
  }, {
    "heading": "pnpm-및-yarn-2에서-이제-prune-지원",
    "content": "새로운 핸드북의 일부로 turbo prune을 사용하여 Docker 이미지 빌드에 대한 섹션도 추가했습니다."
  }, {
    "heading": "pnpm-및-yarn-2에서-이제-prune-지원",
    "content": "자세한 내용은 prune에 대한 이전 블로그를 확인하세요."
  }, {
    "heading": "turbojson의-환경-변수",
    "content": "turbo.json에 두 개의 새로운 키인 env와 globalEnv를 도입했습니다. 이들은 환경 변수를 작업과 별도로 구성할 수 있게 합니다:"
  }, {
    "heading": "turbojson의-환경-변수",
    "content": "globalEnv와 env를 사용하면 $ 접두사 없이 환경 변수 목록을 지정할 수 있습니다. 이는 구성 파일을 훨씬 더 읽기 쉽게 만듭니다. 자세한 내용은 업데이트된 문서를 참조하세요."
  }, {
    "heading": "turbojson의-환경-변수",
    "content": "이전 구문에서 마이그레이션하는 데 도움이 되도록 codemod를 준비했습니다. npx @turbo/codemod migrate-env-var-dependencies를 실행할 수 있습니다."
  }, {
    "heading": "turbojson의-환경-변수",
    "content": "이 작업은 1.4.0에서 추가한 자동 환경 변수 감지를 기반으로 합니다."
  }, {
    "heading": "packagejson-해싱-변경",
    "content": "각 워크스페이스의 package.json 파일은 이제 해당 워크스페이스의 작업에 대한 입력으로 항상 간주됩니다. 이는 package.json에서 작업의 정의를 변경하면 이전 정의의 캐시를 무효화하려는 것을 의미합니다."
  }, {
    "heading": "packagejson-해싱-변경",
    "content": "이는 루트의 package.json에도 적용됩니다. 루트 package.json의 변경은 루트 워크스페이스의 작업을 무효화합니다."
  }, {
    "heading": "packagejson-해싱-변경",
    "content": "이는 Turborepo의 캐시를 조금 더 스마트하게 만들고 작업 정의가 변경될 때 문제가 발생할 가능성을 줄입니다."
  }, {
    "heading": "커뮤니티",
    "content": "8월에 Turborepo v1.4를 출시한 이후 놀라운 채택률과 커뮤니티 성장을 보았습니다:"
  }, {
    "heading": "커뮤니티",
    "content": "9.5k+ GitHub Stars"
  }, {
    "heading": "커뮤니티",
    "content": "주간 NPM 다운로드 440k"
  }, {
    "heading": "커뮤니티",
    "content": "Vercel의 Remote Caching을 통해 15년의 컴퓨팅 시간 절약, 주당 1년 이상 절약, 7월 이후 2배 증가"
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다."
  }, {
    "heading": "커뮤니티",
    "content": "이 릴리스는 다음 분들의 기여로 제공되었습니다: @7flash, @afady, @alexander-young, @atilafassina, @bguedes-moz, @bobaaaaa, @brunojppb, @chris-olszewski, @DoctorJohn, @erj826, @futantan, @gsoltis, @HosseinAgha, @ivov, @jaredpalmer, @joelhooks, @knownasnaffy, @laurentlucian, @leerob, @MarceloAlves, @mattpocock, @mauricekleine, @mehulkar, @Misikir, @nareshbhatia, @nathanhammond, @pakaponk, @PhentomPT, @renovate, @ruisaraiva19, @samuelhorn, @shemayas, @shuding, @t-i-0414, @theurgi, @tknickman, @yanmao-cc 등 더 많은 분들!"
  }, {
    "heading": "커뮤니티",
    "content": "Turborepo를 여러분의 선택한 빌드 도구로 만들기 위한 지속적인 지원, 피드백 및 협력에 감사드립니다."
  }],
  "headings": [{
    "id": "monorepo-handbook",
    "content": "Monorepo Handbook"
  }, {
    "id": "run-생략",
    "content": "run 생략"
  }, {
    "id": "pnpm-및-yarn-2에서-이제-prune-지원",
    "content": "pnpm 및 yarn 2+에서 이제 Prune 지원"
  }, {
    "id": "turbojson의-환경-변수",
    "content": "turbo.json의 환경 변수"
  }, {
    "id": "packagejson-해싱-변경",
    "content": "package.json 해싱 변경"
  }, {
    "id": "커뮤니티",
    "content": "커뮤니티"
  }]
};
import {Authors} from '#components/authors';
import {Callout} from '#components/callout';
import {Date} from '#components/blog/date';
export const toc = [{
  depth: 2,
  url: "#monorepo-handbook",
  title: _jsx(_Fragment, {
    children: "Monorepo Handbook"
  })
}, {
  depth: 2,
  url: "#run-생략",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "run"
    }), " 생략"]
  })
}, {
  depth: 2,
  url: "#pnpm-및-yarn-2에서-이제-prune-지원",
  title: _jsx(_Fragment, {
    children: "pnpm 및 yarn 2+에서 이제 Prune 지원"
  })
}, {
  depth: 2,
  url: "#turbojson의-환경-변수",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "turbo.json"
    }), "의 환경 변수"]
  })
}, {
  depth: 2,
  url: "#packagejson-해싱-변경",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "package.json"
    }), " 해싱 변경"]
  })
}, {
  depth: 2,
  url: "#커뮤니티",
  title: _jsx(_Fragment, {
    children: "커뮤니티"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.5"
    }), "\n", "\n", _jsx(Date, {
      children: "Monday, September 19th, 2022"
    }), "\n", _jsx(Authors, {
      authors: ['mattpocock', 'gregsoltis', 'nathanhammond', 'tomknickman', 'anthonyshew', 'jaredpalmer', 'mehulkar', 'chrisolszewski']
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 1.5는 ", _jsx(_components.strong, {
        children: "문서 및 개발자 경험의 큰 도약"
      }), "이며 ", _jsx(_components.code, {
        children: "turbo prune"
      }), "에 대한 주요 개선 사항을 제공합니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/docs/guides",
          children: _jsx(_components.strong, {
            children: "Monorepo Handbook"
          })
        }), ": 워크스페이스, 코드 공유, 일반적인 도구 통합 등에 대한 가이드인 모노레포를 위한 누락된 매뉴얼을 만들었습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#drop-the-run",
          children: _jsxs(_components.strong, {
            children: [_jsx(_components.code, {
              children: "run"
            }), " 생략"]
          })
        }), ": ", _jsx(_components.code, {
          children: "turbo run <task>"
        }), "를 이제 ", _jsx(_components.code, {
          children: "turbo <task>"
        }), "로 단축할 수 있습니다"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#prune-now-supported-on-pnpm-and-yarn-2",
          children: _jsxs(_components.strong, {
            children: [_jsx(_components.code, {
              children: "turbo prune"
            }), "이 이제 pnpm과 yarn 2+를 지원합니다"]
          })
        }), ": 이제 ", _jsx(_components.code, {
          children: "pnpm"
        }), "과 ", _jsx(_components.code, {
          children: "yarn@berry"
        }), "에서 모노레포 프루닝이 지원됩니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#environment-variables-in-turbojson",
          children: _jsxs(_components.strong, {
            children: [_jsx(_components.code, {
              children: "turbo.json"
            }), "의 환경 변수 개선"]
          })
        }), ": 환경 변수는 이제 Turborepo 파이프라인 구성의 일급 시민입니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#changes-to-packagejson-hashing",
          children: _jsxs(_components.strong, {
            children: [_jsx(_components.code, {
              children: "package.json"
            }), " 해싱 변경"]
          })
        }), ": 작업 실행 시 ", _jsx(_components.code, {
          children: "package.json"
        }), "을 해싱하는 방법을 개선했습니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "npm install turbo@latest"
      }), "를 실행하여 오늘 업데이트하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "monorepo-handbook",
      children: "Monorepo Handbook"
    }), "\n", _jsx(_components.p, {
      children: "모노레포를 처음 설정하는 것은 종종 많은 새로운 개념을 탐색하는 것을 의미합니다. 워크스페이스, 패키지 설치, 코드 공유 및 종속성 관리 등을 이해해야 합니다."
    }), "\n", _jsxs(_components.p, {
      children: ["이는 종종 처음부터 모노레포를 설정하려는 사람들이 다양한 문서 사이트에서 정보를 모아야 함을 의미했습니다. 먼저 ", _jsx(_components.code, {
        children: "pnpm"
      }), ", 그 다음 ", _jsx(_components.code, {
        children: "tsup"
      }), ", 다시 ", _jsx(_components.code, {
        children: "changesets"
      }), ", 그리고 마지막으로 Turborepo로 돌아왔습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["우리는 ", _jsx(_components.a, {
        href: "/docs/guides",
        children: "Monorepo Handbook"
      }), "로 이 격차를 메우고자 합니다. 모노레포로 배포를 성공시키는 데 필요한 모든 도구를 통합하는 방법에 대한 가이드를 만들었습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/crafting-your-repository/managing-dependencies",
          children: "패키지 설치"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/guides/tools/eslint",
          children: "린팅"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/crafting-your-repository/developing-applications",
          children: "개발 작업"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/crafting-your-repository/constructing-ci",
          children: "앱 빌드"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/guides/publishing-libraries",
          children: "패키지 게시"
        })
      }), "\n"]
    }), "\n", _jsxs(_components.h2, {
      id: "run-생략",
      children: [_jsx(_components.code, {
        children: "run"
      }), " 생략"]
    }), "\n", _jsx("iframe", {
      className: "mt-6 h-72 w-full max-w-xl sm:h-96",
      src: "https://www.youtube.com/embed/PEgk2v6KntY",
      title: "YouTube video player",
      frameborder: "0",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    }), "\n", _jsxs(_components.p, {
      children: ["이제 ", _jsx(_components.code, {
        children: "turbo <task>"
      }), "를 사용하여 Turborepo CLI로 작업을 실행할 수 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "- turbo run build"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+ turbo build"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "- turbo run lint build test"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+ turbo lint build test"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["작업 이름이 기본 제공 ", _jsx(_components.code, {
        children: "turbo"
      }), " 하위 명령과 충돌하는 경우 대신 하위 명령을 실행합니다. 즉, ", _jsx(_components.code, {
        children: "prune"
      }), ", ", _jsx(_components.code, {
        children: "run"
      }), " 또는 ", _jsx(_components.code, {
        children: "login"
      }), "과 같은 작업 이름은 사용하지 않아야 합니다. 이들은 기본 제공 하위 명령이기 때문입니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo run <task>"
      }), "는 계속 작동하며 더 이상 사용하지 않을 계획은 없습니다."]
    }), "\n", _jsx(_components.h2, {
      id: "pnpm-및-yarn-2에서-이제-prune-지원",
      children: "pnpm 및 yarn 2+에서 이제 Prune 지원"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/reference/prune",
        children: _jsx(_components.code, {
          children: "turbo prune"
        })
      }), "이 이제 pnpm, yarn 및 yarn 2+를 지원한다는 것을 발표하게 되어 기쁩니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo prune"
      }), "을 사용하여 주어진 대상 애플리케이션과 그 종속성에 필요한 올바른 종속성이 포함된 전용 lockfile과 함께 모노레포의 프루닝된 하위 집합을 만들 수 있습니다. 이는 Docker 이미지 내에서 Turborepo를 효율적으로 사용하는 데 특히 유용합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["새로운 핸드북의 일부로 ", _jsx(_components.code, {
        children: "turbo prune"
      }), "을 사용하여 ", _jsx(_components.a, {
        href: "/docs/guides/tools/docker",
        children: "Docker 이미지 빌드"
      }), "에 대한 섹션도 추가했습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 내용은 ", _jsx(_components.a, {
        href: "/blog/turbo-0-4-0#experimental-pruned-workspaces",
        children: "prune에 대한 이전 블로그"
      }), "를 확인하세요."]
    }), "\n", _jsxs(_components.h2, {
      id: "turbojson의-환경-변수",
      children: [_jsx(_components.code, {
        children: "turbo.json"
      }), "의 환경 변수"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo.json"
      }), "에 두 개의 새로운 키인 ", _jsx(_components.code, {
        children: "env"
      }), "와 ", _jsx(_components.code, {
        children: "globalEnv"
      }), "를 도입했습니다. 이들은 환경 변수를 작업과 ", _jsx(_components.em, {
        children: "별도로"
      }), " 구성할 수 있게 합니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  \"globalDependencies\": ["
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "-   \"$DATABASE_URL\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  ],"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+ \"globalEnv\": ["
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+   \"DATABASE_URL\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+ ],"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  \"pipeline\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    \"build\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      \"dependsOn\": ["
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-deleted)",
                "--shiki-dark": "var(--shiki-token-deleted)"
              },
              children: "-       \"$BUILD_ENV\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      ],"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+     \"env\": ["
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+       \"BUILD_ENV\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+     ]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "globalEnv"
      }), "와 ", _jsx(_components.code, {
        children: "env"
      }), "를 사용하면 ", _jsx(_components.code, {
        children: "$"
      }), " 접두사 ", _jsx(_components.em, {
        children: "없이"
      }), " 환경 변수 목록을 지정할 수 있습니다. 이는 구성 파일을 훨씬 더 읽기 쉽게 만듭니다. 자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#adding-environment-variables-to-task-hashes",
        children: "업데이트된 문서"
      }), "를 참조하세요."]
    }), "\n", _jsxs(_components.p, {
      children: ["이전 구문에서 마이그레이션하는 데 도움이 되도록 codemod를 준비했습니다. ", _jsx(_components.code, {
        children: "npx @turbo/codemod migrate-env-var-dependencies"
      }), "를 실행할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이 작업은 1.4.0에서 추가한 ", _jsx(_components.a, {
        href: "/blog/turbo-1-4-0",
        children: "자동 환경 변수 감지"
      }), "를 기반으로 합니다."]
    }), "\n", _jsxs(_components.h2, {
      id: "packagejson-해싱-변경",
      children: [_jsx(_components.code, {
        children: "package.json"
      }), " 해싱 변경"]
    }), "\n", _jsxs(_components.p, {
      children: ["각 워크스페이스의 ", _jsx(_components.code, {
        children: "package.json"
      }), " 파일은 이제 해당 워크스페이스의 작업에 대한 입력으로 ", _jsx(_components.em, {
        children: "항상"
      }), " 간주됩니다. 이는 ", _jsx(_components.code, {
        children: "package.json"
      }), "에서 작업의 ", _jsx(_components.em, {
        children: "정의"
      }), "를 변경하면 이전 정의의 캐시를 무효화하려는 것을 의미합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이는 루트의 ", _jsx(_components.code, {
        children: "package.json"
      }), "에도 적용됩니다. 루트 ", _jsx(_components.code, {
        children: "package.json"
      }), "의 변경은 루트 워크스페이스의 작업을 무효화합니다."]
    }), "\n", _jsx(_components.p, {
      children: "이는 Turborepo의 캐시를 조금 더 스마트하게 만들고 작업 정의가 변경될 때 문제가 발생할 가능성을 줄입니다."
    }), "\n", _jsx(_components.h2, {
      id: "커뮤니티",
      children: "커뮤니티"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/blog/turbo-1-4-0",
        children: "8월에 Turborepo v1.4를 출시"
      }), "한 이후 놀라운 채택률과 커뮤니티 성장을 보았습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "9.5k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "주간 NPM 다운로드 440k"
        })
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Vercel의 Remote Caching"
        }), "을 통해 15년의 컴퓨팅 시간 절약, 주당 1년 이상 절약, 7월 이후 2배 증가"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다."
    }), "\n", _jsx(_components.p, {
      children: "이 릴리스는 다음 분들의 기여로 제공되었습니다: @7flash, @afady, @alexander-young, @atilafassina, @bguedes-moz, @bobaaaaa, @brunojppb, @chris-olszewski, @DoctorJohn, @erj826, @futantan, @gsoltis, @HosseinAgha, @ivov, @jaredpalmer, @joelhooks, @knownasnaffy, @laurentlucian, @leerob, @MarceloAlves, @mattpocock, @mauricekleine, @mehulkar, @Misikir, @nareshbhatia, @nathanhammond, @pakaponk, @PhentomPT, @renovate, @ruisaraiva19, @samuelhorn, @shemayas, @shuding, @t-i-0414, @theurgi, @tknickman, @yanmao-cc 등 더 많은 분들!"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo를 여러분의 선택한 빌드 도구로 만들기 위한 지속적인 지원, 피드백 및 협력에 감사드립니다."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
